(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('ShipmentDocumentController',ShipmentDocumentController);

    ShipmentDocumentController.$inject = ['$scope','$state','ShipmentDocument','ParseLinks','pagingParams','paginationConstants','AlertService','ToastrService'];

    function ShipmentDocumentController($scope, $state, ShipmentDocument, ParseLinks, pagingParams, paginationConstants, AlertService, ToastrService) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.loadAll = loadAll;
        vm.createTab = createTab;
        vm.convertBoolean = convertBoolean;

        loadAll();

        function loadAll() {
            ShipmentDocument.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc':'desc')];
                if(vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.shipmentDocuments = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                if(error.status !== "404") {
                    ToastrService.error(error.date.message,"Error");
                }
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc':'desc')
            });
        }

        function createTab(data) {
            $scope.$emit('handleEmit', data);
        }

        function convertBoolean(bool) {
            return bool === true ? 'Required':'Not Required';
        }
    }
})();
